import React, { useEffect, useState } from "react";
import { TbPlugConnected } from "react-icons/tb";
import { X } from "lucide-react";
import { integrationData } from "../../utils/constants";

const STORAGE_KEY = "integration_guide_notification_closed";

const IntegrationGuideNotification = ({ handleShowIntegration }) => {
    const [isVisible, setIsVisible] = useState(false);

    // On mount, check localStorage
    useEffect(() => {
        const stored = localStorage.getItem(STORAGE_KEY); // string or null
        // show only if user has NOT closed it before
        setIsVisible(stored !== "true");
    }, []);

    const handleClose = (e) => {
        e.stopPropagation();
        localStorage.setItem(STORAGE_KEY, "true"); // persist closed state
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div
            onClick={handleShowIntegration}
            className="flex justify-between items-center gap-2 px-5 pb-1.5 cursor-pointer">
            <div className="flex items-center gap-1 text-zinc-400">
                <span className="hidden md:inline">
                    <TbPlugConnected />
                </span>
                <span className="text-xs">Connect to your Super Apps</span>
            </div>

            <div className="flex items-center">
                <div className="flex -space-x-1">
                    {integrationData.slice(0, 6).map((item) => (
                        <div
                            key={item.unique_index}
                            className="flex items-center justify-center rounded-full border border-zinc-600 bg-zinc-700 p-1"
                        >
                            <img
                                src={item.image}
                                alt={item.label}
                                className="h-3 w-3 object-contain"
                            />
                        </div>
                    ))}
                </div>

                <button
                    type="button"
                    onClick={(e) => handleClose(e)}
                    className="ml-3 flex h-5 w-5 items-center justify-center text-zinc-500 hover:text-zinc-600"
                    aria-label="Remove"
                >
                    <X className="h-3 w-3" />
                </button>
            </div>
        </div>
    );
};

export default IntegrationGuideNotification;